import { HttpRequest, HttpEvent, HttpInterceptor, HttpResponse, HttpHandler, HttpClient } from "@angular/common/http";
import { Injectable, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { EMPTY, Observable, of, throwError } from "rxjs";
import { filter, tap, delay, distinctUntilChanged, takeUntil } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { ErrorService } from "../error/err.service";
import { AuthService } from "./auth.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService, private router: Router, private errorService: ErrorService) { }

    /* If the Http Client Module imported on multiple modules requires multiple interceptor. Typical interceptor
    only access the global Http Client Module. Avoid importing httpClientModule in each module to avoid this problem.
    */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        ///user/newPwd/post
        if (
            req.url == environment.apiUrl + '/user/secretQtn/get' ||
            req.url == environment.apiUrl + '/user/authCode/get' ||
            req.url == environment.apiUrl + '/user/secretValue/post' ||
            req.url == environment.apiUrl + '/user/newPwd/post' ||
            req.url == environment.apiUrl + '/offline/errorLog/post' ||
            req.url == environment.apiUrl + '/online/errorLog/post' ||
            // req.url == environment.apiUrl + '/userlogin/logout/post' || 
            req.url == environment.apiUrl + '/userlogin/check/userpwd' ||
            req.url == environment.apiUrl + '/error/errorLog/post' ||
            req.url == environment.apiUrl + '/error/errorMetadata/get'
        ) {
            let newbody = typeof (req.body) == "string" ? JSON.parse(req.body) : req.body
            newbody = { ...newbody, ...{ "topicfilter": [req.url.replace(environment.apiUrl, '')] } }

            const cloned = req.clone({
                body: newbody
            });
            return next.handle(cloned)
        }
        else if (
            req.url == environment.apiUrl + '/userlogin/login/post'
        ) {
            let newbody = typeof (req.body) == "string" ? JSON.parse(req.body) : req.body
            newbody = { ...newbody, ...{ "topicfilter": [req.url.replace(environment.apiUrl, '')] } }

            const cloned = req.clone({
                body: newbody
            });
            // return next.handle(cloned)

            return next.handle(cloned).pipe(
                filter((e) => e.type !== 0),
                tap((event: any) => {
                    if (event instanceof HttpResponse) {
                        if (event.headers.has('SPL')) {
                            let payload = event.headers.get('SPL');
                            sessionStorage.setItem('SPL', payload)
                        }

                        if (event.headers.has('SRID')) {
                            let refreshToken = event.headers.get('SRID')
                            sessionStorage.setItem('SRID', refreshToken)
                        }
                    }
                })
            );

        } else if (
            req.url == environment.apiUrl + '/login/auth/refreshToken/get'
        ) {
            if (req instanceof HttpRequest) {
                const payloadObj = sessionStorage.getItem("SPL");
                if (payloadObj) {
                    const cloned = req.clone({
                        headers: req.headers.set("SPL", payloadObj),
                        withCredentials: true
                    });
                    return next.handle(cloned).pipe(
                        filter((e) => e.type !== 0),
                        tap((event: HttpResponse<HttpEvent<any>>) => {
                            if (event.status === 200 && sessionStorage.getItem('serverErrors')) {
                                this.errorService.handleServerDown()
                            }
                        })
                    );
                }
                else {
                    this.authService.logout().subscribe(() => {
                        this.router.navigateByUrl('login')
                        return of(null)
                    })
                }
            }
            else {
                return next.handle(req).pipe(
                    filter((e) => e.type !== 0),
                    tap((event: any) => {
                        if (event instanceof HttpResponse) {
                            if (event.headers.has('SPL')) {
                                let payload = event.headers.get('SPL');
                                sessionStorage.setItem('SPL', payload)
                            }

                            if (event.headers.has('SRID')) {
                                let refreshToken = event.headers.get('SRID')
                                sessionStorage.setItem('SRID', refreshToken)
                            }
                        }
                    })
                );
            }
        }
        else {
            //return next.handle(req)
            const payloadObj = sessionStorage.getItem("SPL");
            if (payloadObj) {
                // console.log("interceptor called", req.url, typeof (req.body), req.body);
                let newbody = typeof (req.body) == "string" ? JSON.parse(req.body) : req.body
                if (newbody.hasOwnProperty("request_type")) {
                    if (newbody["request_type"] == "handshake")
                        newbody = { ...newbody, ...{ "topicfilter": ["long_poll_handshake"] } }
                    else if (newbody["request_type"] == "refresh" || newbody["request_type"] == "cancel")
                        newbody = { ...newbody, ...{ "topicfilter": ["long_poll_request"] } }
                    else
                        newbody = { ...newbody, ...{ "topicfilter": [req.url.replace(environment.apiUrl, '')] } }
                }
                else {
                    newbody = { ...newbody, ...{ "topicfilter": [req.url.replace(environment.apiUrl, '')] } }
                }
                const cloned = req.clone({
                    headers: req.headers.set("SPL", payloadObj),
                    withCredentials: true,
                    // body: req.body.set("topicfilter", ["long_poll_handshake"])
                    body: newbody
                });
                return next.handle(cloned).pipe(
                    filter((e) => e.type !== 0),
                    tap((event: HttpResponse<HttpEvent<any>>) => {
                        if (event.status === 200 && sessionStorage.getItem('serverErrors')) {
                            this.errorService.handleServerDown()
                        }
                    })
                );
            }
            else {
                console.log(this.authService.logout())
                this.authService.logout().subscribe(() => {
                    this.router.navigateByUrl('login')
                    return of(null)
                })
            }
        }
    }
}